import React from "react";

/**
 * The context chip inside the Fawn bar (CUSTODIAN-UI-SPEC §A3.2): a subject the
 * note is "re:", with an × to detach. Free-floating notes (no chip) are
 * first-class, so this only renders when a subject is actually attached.
 */
function ContextChip({ label, onDetach }) {
  return (
    <span className="fawnbar__ctx">
      <span className="fawnbar__ctx-label">{label}</span>
      {onDetach ? (
        <button
          type="button"
          className="fawnbar__ctx-x"
          onClick={onDetach}
          aria-label="Detach context"
        >
          ×
        </button>
      ) : null}
    </span>
  );
}

export default ContextChip;
